// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var MM_syntax_tree = require("../mm-utils/MM_syntax_tree.bs.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Select = require("@mui/material/Select").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var Save = require("@mui/icons-material/Save").default;
var IconButton = require("@mui/material/IconButton").default;
var FormControl = require("@mui/material/FormControl").default;
var DeleteForever = require("@mui/icons-material/DeleteForever").default;
var CancelOutlined = require("@mui/icons-material/CancelOutlined").default;

function rndIconButton(icon, onClick, activeOpt, title, colorOpt, param) {
  var active = activeOpt !== undefined ? activeOpt : true;
  var color = colorOpt !== undefined ? Caml_option.valFromOption(colorOpt) : "primary";
  var tmp = {};
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  var tmp$1 = {
    onClick: (function (param) {
        Curry._1(onClick, undefined);
      }),
    disabled: !active,
    children: icon
  };
  if (color !== undefined) {
    tmp$1.color = color;
  }
  return React.createElement("span", tmp, React.createElement(IconButton, tmp$1));
}

function setNewText(st, text) {
  return {
          newText: text,
          infoExpanded: st.infoExpanded
        };
}

function setInfoExpanded(st, infoExpanded) {
  return {
          newText: st.newText,
          infoExpanded: infoExpanded
        };
}

function leftClickHnd(mouseEvt, clbk, ifNot) {
  if (mouseEvt.button === 0) {
    return Curry._1(clbk, undefined);
  } else {
    return Curry._1(ifNot, mouseEvt);
  }
}

function rndContText(stmtCont) {
  if (stmtCont.TAG === /* Text */0) {
    return stmtCont._0.map(function (stmtSym) {
                var color = stmtSym.color;
                return React.createElement(React.Fragment, {
                            children: color !== undefined ? React.createElement("span", {
                                    style: {
                                      color: color,
                                      fontWeight: "500"
                                    }
                                  }, stmtSym.sym + " ") : stmtSym.sym + " ",
                            key: stmtSym.id
                          });
              });
  } else {
    return MM_syntax_tree.syntaxTreeToSymbols(stmtCont._0).join(" ");
  }
}

var symbolsNotAllowedInLabelRegex = /[\s:]+/g;

function rndProofStatus(proofStatus, readyTooltip, waitingTooltip, noJstfTooltip, jstfIsIncorrectTooltip, onReadyIconClicked, onErrorIconClicked, onNoJstfIconClicked, param) {
  if (proofStatus === undefined) {
    return null;
  }
  switch (proofStatus) {
    case /* Ready */0 :
        var tmp = {
          style: {
            color: "green",
            cursor: Belt_Option.isSome(onReadyIconClicked) ? "pointer" : "default",
            fontWeight: "bold"
          },
          onClick: (function (param) {
              Belt_Option.forEach(onReadyIconClicked, (function (clbk) {
                      Curry._1(clbk, undefined);
                    }));
            })
        };
        if (readyTooltip !== undefined) {
          tmp.title = Caml_option.valFromOption(readyTooltip);
        }
        return React.createElement("span", tmp, "\u2713");
    case /* Waiting */1 :
        var tmp$1 = {
          style: {
            color: "orange",
            fontWeight: "bold"
          }
        };
        if (waitingTooltip !== undefined) {
          tmp$1.title = Caml_option.valFromOption(waitingTooltip);
        }
        return React.createElement("span", tmp$1, "\u223F");
    case /* NoJstf */2 :
        var tmp$2 = {
          style: {
            color: "red",
            cursor: Belt_Option.isSome(onNoJstfIconClicked) ? "pointer" : "default",
            fontWeight: "bold"
          },
          onClick: (function (param) {
              Belt_Option.forEach(onNoJstfIconClicked, (function (clbk) {
                      Curry._1(clbk, undefined);
                    }));
            })
        };
        if (noJstfTooltip !== undefined) {
          tmp$2.title = Caml_option.valFromOption(noJstfTooltip);
        }
        return React.createElement("span", tmp$2, "?");
    case /* JstfIsIncorrect */3 :
        var tmp$3 = {
          style: {
            color: "red",
            cursor: Belt_Option.isSome(onErrorIconClicked) ? "pointer" : "default",
            fontWeight: "bold"
          },
          onClick: (function (param) {
              Belt_Option.forEach(onErrorIconClicked, (function (clbk) {
                      Curry._1(clbk, undefined);
                    }));
            })
        };
        if (jstfIsIncorrectTooltip !== undefined) {
          tmp$3.title = Caml_option.valFromOption(jstfIsIncorrectTooltip);
        }
        return React.createElement("span", tmp$3, "\u2717");
    
  }
}

function MM_cmp_user_stmt(Props) {
  var stmt = Props.stmt;
  var onLabelEditRequested = Props.onLabelEditRequested;
  var onLabelEditDone = Props.onLabelEditDone;
  var onLabelEditCancel = Props.onLabelEditCancel;
  var onTypEditRequested = Props.onTypEditRequested;
  var onTypEditDone = Props.onTypEditDone;
  var onContEditRequested = Props.onContEditRequested;
  var onContEditDone = Props.onContEditDone;
  var onContEditCancel = Props.onContEditCancel;
  var onJstfEditRequested = Props.onJstfEditRequested;
  var onJstfEditDone = Props.onJstfEditDone;
  var onJstfEditCancel = Props.onJstfEditCancel;
  var onGenerateProof = Props.onGenerateProof;
  var onDebug = Props.onDebug;
  var match = React.useState(function () {
        return {
                newText: "",
                infoExpanded: false
              };
      });
  var setState = match[1];
  var state = match[0];
  var labelRef = React.useRef(null);
  React.useEffect((function () {
          if (stmt.labelEditMode) {
            Curry._1(setState, (function (__x) {
                    return setNewText(__x, stmt.label);
                  }));
          } else if (stmt.typEditMode) {
            Curry._1(setState, (function (__x) {
                    return setNewText(__x, MM_wrk_editor.userStmtTypeToStr(stmt.typ));
                  }));
          } else if (stmt.contEditMode) {
            Curry._1(setState, (function (__x) {
                    return setNewText(__x, MM_wrk_editor.contToStr(stmt.cont));
                  }));
          } else if (stmt.jstfEditMode) {
            Curry._1(setState, (function (__x) {
                    return setNewText(__x, stmt.jstfText);
                  }));
          }
          
        }), [
        stmt.labelEditMode,
        stmt.typEditMode,
        stmt.contEditMode,
        stmt.jstfEditMode
      ]);
  var actToggleInfoExpanded = function (param) {
    Curry._1(setState, (function (st) {
            return setInfoExpanded(st, !st.infoExpanded);
          }));
  };
  var actNewTextUpdated = function (newText) {
    Curry._1(setState, (function (__x) {
            return setNewText(__x, newText);
          }));
  };
  var actLabelEditDone = function (param) {
    Curry._1(onLabelEditDone, state.newText.replace(symbolsNotAllowedInLabelRegex, ""));
  };
  var actLabelEditCancel = function (param) {
    Curry._1(onLabelEditCancel, state.newText.replace(symbolsNotAllowedInLabelRegex, ""));
  };
  var actTypEditDone = function (newTypStr) {
    Curry._1(onTypEditDone, MM_wrk_editor.userStmtTypeFromStr(newTypStr));
  };
  var actContEditDone = function (param) {
    Curry._1(onContEditDone, state.newText.trim());
  };
  var actContEditCancel = function (param) {
    Curry._1(onContEditCancel, state.newText.trim());
  };
  var actJstfEditDone = function (param) {
    Curry._1(setState, (function (st) {
            return setInfoExpanded(st, true);
          }));
    Curry._1(onJstfEditDone, state.newText.trim());
  };
  var actJstfEditCancel = function (param) {
    Curry._1(onJstfEditCancel, state.newText.trim());
  };
  var actJstfDeleted = function (param) {
    Curry._1(onJstfEditDone, "");
  };
  var rndLabel = function (param) {
    if (!stmt.labelEditMode) {
      return React.createElement("span", {
                  ref: labelRef,
                  title: "<left-click> to change",
                  onClick: (function (__x) {
                      leftClickHnd(__x, onLabelEditRequested, (function (param) {
                              
                            }));
                    })
                }, stmt.label);
    }
    var partial_arg = actLabelEditCancel;
    var partial_arg$1 = actLabelEditDone;
    return React.createElement(Expln_React_Row.make, {
                children: null
              }, React.createElement(TextField, {
                    value: state.newText,
                    size: "small",
                    style: {
                      width: "100px"
                    },
                    onChange: (function (param) {
                        return Expln_React_common.evt2str((function (str) {
                                      var newText = str.replace(symbolsNotAllowedInLabelRegex, "");
                                      Curry._1(setState, (function (__x) {
                                              return setNewText(__x, newText);
                                            }));
                                    }), param);
                      }),
                    onKeyDown: (function (param) {
                        return MM_react_common.kbrdHnd(undefined, partial_arg$1, partial_arg, undefined, param);
                      }),
                    autoFocus: true,
                    title: "Enter to save, Esc to cancel"
                  }), rndIconButton(React.createElement(Save, {}), actLabelEditDone, state.newText.trim() !== "", "Save, Enter", undefined, undefined), rndIconButton(React.createElement(CancelOutlined, {}), actLabelEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined), undefined));
  };
  var rndCont = function (param) {
    if (!stmt.contEditMode) {
      return React.createElement(Paper, {
                  onClick: (function (__x) {
                      leftClickHnd(__x, onContEditRequested, (function (param) {
                              
                            }));
                    }),
                  style: {
                    backgroundColor: "rgb(255,255,235)",
                    fontFamily: "monospace",
                    fontSize: "1.3em",
                    padding: "1px 10px"
                  },
                  title: "<left-click> to change",
                  children: rndContText(stmt.cont)
                });
    }
    var windowWidth = window.innerWidth;
    var domElem = labelRef.current;
    var labelWidth = !(domElem == null) ? domElem.offsetWidth : 0;
    var partial_arg = actContEditCancel;
    var partial_arg$1 = actContEditDone;
    return React.createElement(Expln_React_Row.make, {
                children: null
              }, React.createElement(TextField, {
                    value: state.newText,
                    size: "small",
                    style: {
                      width: String((windowWidth - 200 | 0) - labelWidth | 0) + "px"
                    },
                    multiline: true,
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(actNewTextUpdated, param);
                      }),
                    onKeyDown: (function (param) {
                        return MM_react_common.kbrdHnd(undefined, partial_arg$1, partial_arg, undefined, param);
                      }),
                    inputProps: {
                      style: {
                        fontFamily: "monospace"
                      }
                    },
                    autoFocus: true,
                    title: "Enter to save, Shift+Enter to start a new line, Esc to cancel"
                  }), rndIconButton(React.createElement(Save, {}), actContEditDone, state.newText.trim() !== "", "Save, Enter", undefined, undefined), rndIconButton(React.createElement(CancelOutlined, {}), actContEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined), undefined));
  };
  var rndTyp = function (param) {
    if (stmt.typEditMode) {
      return React.createElement(FormControl, {
                  size: "small",
                  children: React.createElement(Select, {
                        value: "",
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actTypEditDone, param);
                          }),
                        children: null
                      }, React.createElement(MenuItem, {
                            value: "e",
                            children: "H"
                          }), React.createElement(MenuItem, {
                            value: "p",
                            children: "P"
                          }))
                });
    }
    var match = stmt.typ;
    var typStr = match ? "P" : "H";
    return React.createElement("span", {
                style: {
                  cursor: "pointer",
                  fontWeight: "bold"
                },
                title: "Alt+<left-click> to change statement type. Left-click to show/hide the justification for provable.",
                onClick: (function (__x) {
                    var ifNot = function (param) {
                      actToggleInfoExpanded(undefined);
                    };
                    if (__x.button === 0 && __x.altKey) {
                      return Curry._1(onTypEditRequested, undefined);
                    } else {
                      return Curry._1(ifNot, __x);
                    }
                  })
              }, typStr.toUpperCase());
  };
  var rndInfoBody = function (param) {
    if (stmt.typ === /* P */1 && (state.infoExpanded || stmt.jstfEditMode)) {
      if (stmt.jstfEditMode) {
        var partial_arg = actJstfEditCancel;
        var partial_arg$1 = actJstfEditDone;
        return React.createElement(Expln_React_Row.make, {
                    children: null
                  }, React.createElement(TextField, {
                        value: state.newText,
                        label: "Justification",
                        size: "small",
                        style: {
                          width: "600px"
                        },
                        multiline: true,
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actNewTextUpdated, param);
                          }),
                        onKeyDown: (function (param) {
                            return MM_react_common.kbrdHnd(undefined, partial_arg$1, partial_arg, undefined, param);
                          }),
                        autoFocus: true,
                        title: "Enter to save, Esc to cancel"
                      }), rndIconButton(React.createElement(Save, {}), actJstfEditDone, true, "Save, Enter", undefined, undefined), rndIconButton(React.createElement(CancelOutlined, {}), actJstfEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined), undefined));
      }
      var jstfText = stmt.jstfText === "" ? " " : stmt.jstfText;
      var padding = jstfText.trim() === "" ? "10px 30px" : "3px";
      return React.createElement(Expln_React_Row.make, {
                  children: null
                }, React.createElement(Paper, {
                      onClick: (function (__x) {
                          leftClickHnd(__x, onJstfEditRequested, (function (param) {
                                  
                                }));
                        }),
                      style: {
                        marginTop: "5px",
                        padding: padding
                      },
                      title: "<left-click> to change",
                      children: jstfText
                    }), jstfText.trim() === "" ? null : React.createElement("span", undefined, rndIconButton(React.createElement(DeleteForever, {}), actJstfDeleted, undefined, "Clear", Caml_option.some(undefined), undefined)));
    } else {
      return null;
    }
  };
  return React.createElement("table", {
              style: {
                margin: "-5px"
              }
            }, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, rndProofStatus(stmt.proofStatus, "Proof is ready, left-click to generate compressed proof", "Justification for this statement is correct", "Justification cannot be determined automatically. Click to debug.", "Justification is incorrect. Click to debug.", onGenerateProof, onDebug, onDebug, undefined)), React.createElement("td", undefined, rndLabel(undefined)), React.createElement("td", undefined, rndTyp(undefined)), React.createElement("td", undefined, rndCont(undefined))), React.createElement("tr", undefined, React.createElement("td", undefined, null), React.createElement("td", undefined, null), React.createElement("td", undefined, null), React.createElement("td", undefined, rndInfoBody(undefined)))));
}

var make = MM_cmp_user_stmt;

exports.rndProofStatus = rndProofStatus;
exports.make = make;
exports.rndContText = rndContText;
/* react Not a pure module */
